import React from 'react';

import TabPageContainer from '~components/atoms/TabPageContainer';
import { useAppDispatch } from '~redux/hooks';
import EarmarkApprovalSearchAndFilterBar from './EarmarkApprovalSearchAndFilterBar';
import EarmarkApprovalTable from './EarmarkApprovalTable';
import EarmarkApprovalPaginator from './EarmarkApprovalPaginator';
import ConfirmEarmarkApprovalModal from './ConfirmEarmarkApprovalModal';

const EarmarkApproval = () => {
    const dispatch = useAppDispatch();

    return (
        <TabPageContainer>
            <EarmarkApprovalSearchAndFilterBar />

            <EarmarkApprovalTable />

            <EarmarkApprovalPaginator />

            <ConfirmEarmarkApprovalModal />
        </TabPageContainer>

    );
};

export default EarmarkApproval;
